angular.module('impactx.system').controller('ThemeConfiguratorCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$location',
    '$window',
    '$routeParams',
    'BackService',
    'ToolbarService',
    ThemeConfiguratorController
]);

function ThemeConfiguratorController($scope, dataGen, ToastService, $location, $window, $routeParams, BackService, ToolbarService) {
    var comId = $routeParams.comId;
    var self = this;
    self.showLogo = comId > 0;

    dataGen.getData(self, {comId: comId}, "/theme/config/view").then(function (response) {
        if (!impactX.isDefined(response, 'data.shop.primary')) {
            self.data.shop.primary = removeLeadingHash(getShopPalette().primary["500"]);
            self.data.shop.accent = removeLeadingHash(getShopPalette().accent["A200"]);
        }
        if (!impactX.isDefined(response, 'data.content.primary')) {
            self.data.content.primary = removeLeadingHash(getContentPalette().primary["500"]);
            self.data.content.accent = removeLeadingHash(getContentPalette().accent["A200"]);
        }
        if (self.data.hasBusinessLicence) {
            if (!impactX.isDefined(response, 'data.monitor.primary')) {
                self.data.monitor.primary = removeLeadingHash(getMonitorPalette().primary["500"]);
                self.data.monitor.accent = removeLeadingHash(getMonitorPalette().accent["A200"]);
            }
        }
        if (!impactX.isDefined(response, 'data.admin.primary')) {
            self.data.admin.primary = removeLeadingHash(getAdminPalette().primary["500"]);
            self.data.admin.accent = removeLeadingHash(getAdminPalette().accent["A200"]);
        }
        if (!impactX.isDefined(response, 'data.system.primary')) {
            self.data.system.primary = removeLeadingHash(getSystemPalette().primary["500"]);
            self.data.system.accent = removeLeadingHash(getSystemPalette().accent["A200"]);
        }

        defineButtons();
    });

    self.saveThemeConfig = function () {
        return dataGen.postAsForm({}, {themeData: self.data, comId: comId}, '/theme/config/save').then(function () {
            ToastService.openActionToast(self.trns.toastMessage, self.trns.refresh, function () {
                $window.location.reload();
            });
        });
    };

    self.deleteThemeConfig = function () {
        return dataGen.postAsForm({}, {comId: comId}, '/theme/config/delete').then(function () {
            BackService.back();

            ToastService.openActionToast(self.trns.toastMessageDelete, self.trns.refresh, function () {
                $window.location.reload();
            });
        });
    };

    function removeLeadingHash(value) {
        if (value) {
            var indexOf = value.indexOf('#');
            if (indexOf >= 0) {
                return value.replace('#', '');
            }
        }
        return value;
    }

    self.deleteNewLogo = function () {
        self.data.newLogo.fileName = undefined;
        self.data.newLogo.file = undefined;
        document.querySelector('#fileInputlogo').value = "";
    };

    self.deleteCurrentLogo = function () {
        self.data.currentLogo.isDeleted = true;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: self.trns.save,
                action: self.saveThemeConfig,
                type: 'dialogaction'
            },
            {
                label: self.trns.delete,
                action: self.deleteThemeConfig,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return self.data.canDelete;
    }
}